module.exports = __webpack_public_path__ + "static/media/salu-logo.b3dc9e2e.svg";